import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

export const useLocationQuery = () => {
  return queryString.parse(useLocation().search);
};
